ACPVisualGuidelinesStore = require 'stores/acp_visual_guidelines_store'
ACPVisualGuidelinesActions = require 'actions/acp_visual_guidelines_actions'
ConnectStore = require 'components/enhancers/connect_store'
EtdsStore = require 'stores/etds_store'
QuestionsStore = require 'stores/questions_store'
QuestionGroupsStore = require 'stores/question_groups_store'
OverarchingQuestionsStore = require 'stores/overarching_questions_store'
QuestionsSelector = require 'components/common/questions_selector'
{ useCoffeeCallback } = require 'lib/react_utils'

storeConnector =
  ACPVisualGuidelinesStore: (Store) ->
    editingVisualization: Store.getEditingVisualization()
  EtdsStore: (Store) ->
    etds: Store.getEtds()
  QuestionsStore: (Store) ->
    questions: Store.getQuestions()
  QuestionGroupsStore: (Store) ->
    questionGroups: Store.getQuestionGroups()
  OverarchingQuestionsStore: (Store) ->
    overarchingQuestions: Store.getOverarchingQuestions()

QuestionsSelectorField = ({
  etds
  questions
  overarchingQuestions
  questionGroups
  editingVisualization
}) ->

  updateSelectedQuestions = useCoffeeCallback [], (selectedQuestions) ->
    ACPVisualGuidelinesActions.updateEditingVisualization({
      key: 'selectedQuestions',
      value: selectedQuestions
    })

  <div>
    <QuestionsSelector
      etds={etds}
      questionGroups={questionGroups}
      questions={questions.merge(overarchingQuestions)}
      selectedQuestions={editingVisualization.get('selectedQuestions', Immutable.List())}
      updateSelected={updateSelectedQuestions}
      withRecommendationText
    />
  </div>


module.exports = ConnectStore QuestionsSelectorField, [
  ACPVisualGuidelinesStore
  EtdsStore
  QuestionGroupsStore
  QuestionsStore
  OverarchingQuestionsStore
], storeConnector
